const Events = {
    ERROR: 'ERROR',
    GET_SEI_INFO: 'GET_SEI_INFO',
    FRAG_PARSED: 'FRAG_PARSED',
    INIT_PTS_FOUND: 'INIT_PTS_FOUND',
    FRAG_PARSING_INIT_SEGMENT: 'FRAG_PARSING_INIT_SEGMENT',
    FRAG_PARSING_METADATA: 'FRAG_PARSING_METADATA',
    FRAG_PARSING_USERDATA: 'FRAG_PARSING_USERDATA',
    MEDIA_INFO: 'MEDIA_INFO',
    MEDIA_DATA_ARRIVED: 'MEDIA_DATA_ARRIVED',
    SCRIPT_DATA_ARRIVED: 'SCRIPT_DATA_ARRIVED',
    // 当转码器解析出初始化片段时触发
    INIT_SEGMENT: 'INIT_SEGMENT',
    // 当转码器解析出媒体化片段时触发
    MEDIA_SEGMENT: 'MEDIA_SEGMENT'
};

export default Events;
